import React, { Fragment } from 'react';
import { DefaultQueryParams, parseQuery, useTranslation } from '@pascal/pascal-core';
import { useLocation } from 'react-router-dom';
import {
  GAME_RULES_HELP_KEYS,
  GAME_RULES_HELP_KEYS_TURBO,
  TURBO_OR_TERMINAL_GAME_ID,
} from '../../enums/constants';
import turboHelpImg1 from '../../assets/images/rules/img_1.png';
import turboHelpImg2 from '../../assets/images/rules/img_2.png';
import turboHelpImg3 from '../../assets/images/rules/img_3.png';
import turboHelpImg4 from '../../assets/images/rules/img_4.png';
import turboHelpImg5 from '../../assets/images/rules/img_5.png';
import turboHelpImg6 from '../../assets/images/rules/img_6.png';
import turboHelpImg7 from '../../assets/images/rules/img_7.png';

import surrender from '../../assets/images/rules/infoSurrender.png';
import blackjack from '../../assets/images/rules/infoBlackjack.png';
import handInfo from '../../assets/images/rules/infoHand.png';
import handHands from '../../assets/images/rules/infoHandHands.png';
import pushInfo from '../../assets/images/rules/infoPush.png';
import LimitAndPayouts from '../../containers/payoutsAndResultsContainer/limitsAndPayouts';

const sortedTurboImages = {
  2: turboHelpImg1,
  25: turboHelpImg2,
  26: turboHelpImg3,
  27: turboHelpImg4,
  28: turboHelpImg5,
  30: handHands,
  31: handInfo,
  33: blackjack,
  39: turboHelpImg6,
  43: pushInfo,
  44: turboHelpImg7,
  45: surrender,
};

export function HelpPopup() {
  const t = useTranslation();
  const { search } = useLocation();
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(search);
  const isTurbo = +gameId === TURBO_OR_TERMINAL_GAME_ID;

  return (
    <>
      <div className='c-m-game-rules'>
        {/* <div className='c-m-game-rules-img'> */}
        {/*  <img src={surrender} alt='' /> */}
        {/* </div> */}
        {/* <div className='c-m-game-rules-img'> */}
        {/*  <img src={blackjack} alt='' /> */}
        {/* </div> */}
        {/* <div className='c-m-game-rules-img'> */}
        {/*  <img src={handInfo} alt='' /> */}
        {/* </div> */}
        {/* <div className='c-m-game-rules-img'> */}
        {/*  <img src={handHands} alt='' /> */}
        {/* </div> */}
        {/* <div className='c-m-game-rules-img'> */}
        {/*  <img src={pushInfo} alt='' /> */}
        {/* </div> */}
        {isTurbo
          ? GAME_RULES_HELP_KEYS_TURBO.map((item) => (
              <Fragment key={item}>
                <p className='blackjack-modal-par'>{t(`GAME_RULES_P${item + 1}`)}</p>
                {
                  // eslint-disable-next-line no-nested-ternary
                  !!sortedTurboImages?.[item] && item === 2 ? (
                    <div className='help-popup-deal-btn'>
                      <button type='button' className='tb-deal-button'>
                        <span>{t('DEAL')}</span>
                      </button>
                    </div>
                  ) : // eslint-disable-next-line
                  !!sortedTurboImages?.[item] ? (
                    <div className='c-m-game-rules-img'>
                      <img
                        className={`${item === 44 ? 'game-rules-img-big' : ''}`}
                        src={sortedTurboImages?.[item]}
                        alt=''
                      />
                    </div>
                  ) : null
                }
              </Fragment>
            ))
          : GAME_RULES_HELP_KEYS.map((item) => (
              <p key={item} className='blackjack-modal-par'>
                {t(`GAME_RULES_P${item + 1}`)}
              </p>
            ))}
        <p className='blackjack-modal-par'>{t('CANCELATION_MESSAGE_1')}</p>
        <p className='blackjack-modal-par'>{t('MALFUNCTION_MESSAGE_2')}</p>
      </div>
      <p className='game-rule-table-row-item-txt'>{t('PAYOUT_TABLE')}</p>
      <div className='game-rule-table'>
        <div className='game-rule-table-row title'>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('BET')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('OUTCOME')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('ODD')}</p>
          </div>
        </div>
        <div className='game-rule-table-row'>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('MAIN')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('BLACKJACK')}</p>
            <p className='game-rule-table-row-item-txt'>{t('WIN')}</p>
            <p className='game-rule-table-row-item-txt'>{t('INSURANCE')}</p>
            <p className='game-rule-table-row-item-txt'>{t('SURRENDER')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>2.5</p>
            <p className='game-rule-table-row-item-txt'>2</p>
            <p className='game-rule-table-row-item-txt'>3</p>
            <p className='game-rule-table-row-item-txt'>0.5</p>
          </div>
        </div>
        <div className='game-rule-table-row'>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('SIDE_21_PLUS_3')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('FLUSH')}</p>
            <p className='game-rule-table-row-item-txt'>{t('STRAIGHT')}</p>
            <p className='game-rule-table-row-item-txt'>{t('THREE_OF_A_KIND')}</p>
            <p className='game-rule-table-row-item-txt'>{t('STRAIGHT_FLUSH')}</p>
            <p className='game-rule-table-row-item-txt'>{t('SUITED_TRIPS')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>6</p>
            <p className='game-rule-table-row-item-txt'>11</p>
            <p className='game-rule-table-row-item-txt'>31</p>
            <p className='game-rule-table-row-item-txt'>41</p>
            <p className='game-rule-table-row-item-txt'>101</p>
          </div>
        </div>
        <div className='game-rule-table-row'>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('PERFECT_PAIR')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('MIXED_PAIR')}</p>
            <p className='game-rule-table-row-item-txt'>{t('COLORED_PAIR')}</p>
            <p className='game-rule-table-row-item-txt'>{t('PERFECT_PAIR')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>6</p>
            <p className='game-rule-table-row-item-txt'>13</p>
            <p className='game-rule-table-row-item-txt'>26</p>
          </div>
        </div>
      </div>

      {/* LIMITS AND PAYOUTS START */}
      <div className='game-rule-limits-and-payouts'>
        <p className='game-rule-limits-and-payouts-txt'>{t('BET')}</p>
        <p className='game-rule-limits-and-payouts-txt'>{t('MAX_PAYOUT')}</p>
      </div>
      <LimitAndPayouts isFromRules />
      <br />
      {/* LIMITS AND PAYOUTS END */}

      <p className='game-rule-table-row-item-txt'>{t('RTP')}</p>
      <div className='game-rule-table'>
        <div className='game-rule-table-row title'>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('BET')}</p>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>{t('RTP')}</p>
          </div>
        </div>
        <div className='game-rule-table-row'>
          <div className='game-rule-table-row-item'>
            <div className='game-rule-table-row-item'>
              <p className='game-rule-table-row-item-txt'>{t('MAIN')}</p>
              <p className='game-rule-table-row-item-txt'>{t('SIDE_21_PLUS_3')}</p>
              <p className='game-rule-table-row-item-txt'>{t('PERFECT_PAIR')}</p>
            </div>
          </div>
          <div className='game-rule-table-row-item'>
            <p className='game-rule-table-row-item-txt'>99.47%</p>
            <p className='game-rule-table-row-item-txt'>96.30%</p>
            <p className='game-rule-table-row-item-txt'>92.05%</p>
          </div>
        </div>
      </div>
    </>
  );
}
